import { type CSSProperties, type HTMLAttributes, useEffect, useRef } from "react";
import type { MiniMapController, MiniMapOptions } from "../index";
import { useViewer } from "./context";
import { getReactRuntimeFactories } from "./runtime";
export interface MiniMapProps extends Omit<HTMLAttributes<HTMLDivElement>, "children" | "role"> {
  theme?: MiniMapOptions["theme"];
  highlightedIds?: Iterable<string> | null;
  style?: CSSProperties;
}
export function MiniMap({
  theme,
  highlightedIds = null,
  className,
  style,
  "aria-label": ariaLabel = "Graph minimap",
  ...divProps
}: MiniMapProps) {
  const viewer = useViewer();
  const hostRef = useRef<HTMLDivElement>(null);
  const minimapRef = useRef<MiniMapController | null>(null);
  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const minimap = getReactRuntimeFactories().createMiniMap(host, viewer);
    minimapRef.current = minimap;
    return () => {
      minimapRef.current = null;
      minimap.dispose();
    };
  }, [viewer]);
  useEffect(() => minimapRef.current?.setTheme(theme), [theme]);
  useEffect(() => minimapRef.current?.setHighlights(highlightedIds), [highlightedIds]);
  return <div {...divProps} ref={hostRef} className={className} style={style} role="img" aria-label={ariaLabel} />;
}